module.exports = __webpack_public_path__ + "img/funding-new12.7b4ede13.png";